module.exports = __webpack_public_path__ + "img/ring_r_e_1_1@3x.94cfce2b.png";